import { FeatureResponse, No, Unclear, Unresolved, Yes } from "./FeatureResponse";
import { Syndrome } from "./Syndrome";

export class Generalized extends Syndrome {

    getName() {
        return "Generalized";
    }

    checkMandatorySeizures(seizures: any[]): FeatureResponse {
        for (const seizure of seizures) {
            if(seizure.mainType === "generalized") 
                return new Yes("Mandatory: Generalized seizures present.");
        }
        return new No("Mandatory generalized seizures not present.");
    }

}